let objEach = (obj, callback) => {
    let counter = 0;
    for (let key in obj)
    {
        if ( obj.hasOwnProperty(key) )
        {
            callback( key, obj[key], counter );
        }
        counter ++;
    }
};

let isEmptyObj = (obj) =>
{
    if (!(obj instanceof Object))
        return false;

    for(let prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
    }
    return true;
};

let clone = function(obj)
{
    if (!(obj instanceof Object))
    {
        return obj
    }
    try {
        return JSON.parse(JSON.stringify(obj))
    }
    catch(e)
    {
        return obj
    }
};

let uniq = (arr, fn, options = {}) =>
{
    let result = arr.reduce((res, item) =>
    {
        let key = fn ? fn(item) : item;
        res[key] = options.keep_first && res[key] ? res[key] : item;
        return res
    }, {});

    return Object.keys(result).map(key => result[key])
};

let capitalizeFirstLetter = (string) =>
{
    return string.charAt(0).toUpperCase() + string.slice(1);
};

let dateTime = {
    add : (date, period, value) =>
    {
        if(!date)
            return ""
        date = date?.getFullYear ? date : new Date(date);
        switch (period)
        {
            case 'minute':
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes() + value, date.getSeconds(), date.getMilliseconds());
            case 'hour':
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() + value, date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            case 'day':
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() + value, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            case 'week':
                return new Date(date.getFullYear(), date.getMonth(), date.getDate() + (value*7), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            case 'month':
                return new Date(date.getFullYear(), date.getMonth() + value, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            case 'year':
                return new Date(date.getFullYear() + value, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            default:
                return date
        }
    },
    clearHours: (date) =>
    {
        date = date.getFullYear ? date : new Date(date);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },

    secondsToTime: (time) => {
        let hours = Math.floor(time / 3600);
        time -= hours * 3600;

        let minutes = Math.floor(time / 60);
        time -= minutes * 60;

        let seconds = parseInt(time % 60, 10);

        return [hours, minutes, seconds];
    }
};

let addZero = (value) =>
{
    if (value >= 0 && value < 10)
    {
        return "0" + value;
    }
    return value;
};

let parseCookies = () => {
    let result = {};
    if (typeof document === "undefined")
        return result;

    let cookies = document.cookie;
    if (cookies.length === 0)
    {
        return result
    }
    let splitBySingle = cookies.split('; ');
    splitBySingle.forEach(function(cookie)
    {
        let first_sign = cookie.indexOf("=");
        result[cookie.slice(0, first_sign)] = cookie.slice(first_sign + 1, cookie.length)
    });
    return result;
};

let getCookie = (cookieName) =>
{
    let cookies = parseCookies();
    return cookies[cookieName]
};

let setCookie = (cookieName, value, expires, path, domain) => {
    let result = [cookieName + '=' + value];
    if (expires)
    {
        result.push('expires=' + expires)
    }
    if (path)
    {
        result.push('path=' + path)
    }
    if (domain)
    {
        result.push('domain=' + path)
    }
    document.cookie = result.join('; ')
};

const randomIntInRange = (min, max) => {
    // min inclusive, max exlusive
    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(Math.random() * (max - min)) + min
}

const randomFloatInRange = ({
    min = 0,
    max = 1,
    toFixed = null,

} = {}) => {

    if (toFixed !== null && typeof toFixed !== "number") {
        throw new Error("toFixed parameter must be positive integer number")
    }

    if (toFixed % 1 !== 0 || toFixed < 0) {
        throw new Error("toFixed parameter must be positive integer number")
    }

    const number = Math.random() * (max - min) + min;

    if (toFixed) {
        return +number.toFixed(toFixed)
    }

    return Math.random() * (max - min) + min;
};

let format = function(str) //in arrow function arguments not working!!!
{
    for( let i = 1; i < arguments.length; i++ )
    {
        let regexp = new RegExp( '\\{' + (i - 1) + '\\}', 'gim' );
        str = str.replace( regexp, arguments[i] );
    }
    return str;
};


let getValueFromJSON = (jsn, key) =>
{
    if (!key)
    {
        return jsn;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    if (!jsn || !jsn.hasOwnProperty(currentKey))
    {
        return null;
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey];
    }

    parseData.shift();
    return getValueFromJSON(jsn[currentKey], parseData.join('.'))
};

let setValueInJSON = (jsn, key, value) => {
    if (!key)
    {
        return;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    let nextKey = parseData[1];
    let isArray = parseInt(nextKey, 10).toString() === nextKey;

    if (!jsn.hasOwnProperty(currentKey))
    {
        if (isArray)
        {
            jsn[currentKey] = [];
        }
        else
        {
            jsn[currentKey] = {};
        }
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey] = value;
    }

    parseData.shift();
    return setValueInJSON(jsn[currentKey], parseData.join('.'), value)
};

let renderHours = (iso_date) => {
    let date = new Date(iso_date);

    return `${addZero(date.getHours())}:${addZero(date.getMinutes())}`
};

let renderDate = (iso_date, options = {}) => {
    let date = new Date(iso_date);

    return `${addZero(date.getDate())}-${addZero(date.getMonth() + 1)}-${date.getFullYear()}${options.show_hours ? ` ${renderHours(date)}` : ""}`
};

let getHumanName = human => {
    // if (human.name) {
    //     return human.name
    // }
    return human._id
}

let getHumanEGN = human => {
    return ""
}

const password_generator = (length = 8) => {
    let symbol_groups = ["abcdefghijklmnopqrstuvwxyz", "ABCDEFGHIJKLMNOPQRSTUVWXYZ", "0123456789", "#$@-"];
    let retVal = "";

    for (let i = 0; i < length; i++) {
        let symbols = symbol_groups[Math.floor(Math.random() * symbol_groups.length)];
        retVal += symbols.charAt(Math.floor(Math.random() * symbols.length));
    }

    if (!/[0-9]/.test(retVal)){
        return password_generator(length);
    }
    else if (!/[A-Z,А-Я]/.test(retVal)){
        return password_generator(length);
    }
    else if (!/[a-z,а-я]/.test(retVal)) {
        return password_generator(length);
    }

    return retVal;
};

let format_currency = ({value, currency_sign = "", hide_decimal, delimiter = ",", fixed = 2}) =>
{
    let intPart = parseInt(value || 0, 10).toString();
    let length = intPart.length;

    let res = "";

    for (let i = length; i >= 0; i-=3)
    {
        res = (i - 3 > 0 ? delimiter : "") + intPart.slice(Math.max(i -3,0), i) + res;
    }

    if (hide_decimal)
        return `${res} ${currency_sign}`;

    let decimal = parseFloat(value || 0).toFixed(fixed).split(".").pop();

    return `${res}.${decimal} ${currency_sign}`
};

/**
 *
 * @param {object} props
 * @param {number} props.value
 * @param {number|"auto"} [props.decimal]
 * @param {string} [props.delimiter]
 * @param {string} [props.suffix]
 * @returns {string}
 */
const numberFormat = (props) =>
{
    const {value = 0, decimal = 0, delimiter = ",", suffix = ""} = props;
    const intPart = Math.floor(value).toString();
    const length = intPart.length;
    let res = "";

    for (let i = length; i >= 0; i-=3)
        res = (i - 3 > 0 ? delimiter : "") + intPart.slice(Math.max(i -3,0), i) + res;

    if (!decimal)
        return res;

    let decimalLength = 0;

    if (decimal === "auto")
        decimalLength = value.toString().split(".")[1]?.length || 0
    else
        decimalLength = decimal

    if (!decimalLength)
        return `${res}${suffix}`;

    const decimalPart = value.toFixed(decimalLength).split(".").pop();


    return `${res}.${decimalPart}${suffix}`
};

const ms_to_hours = (ms) =>
{
    let hours = Math.floor(ms / (1000 * 60 * 60));
    let rest = ms % (1000 * 60 * 60);
    let minutes = Math.floor((rest || ms) / (1000 * 60));
    rest = (rest || ms) % (1000 * 60);
    let seconds = Math.floor((rest || ms) / 1000);
    rest = (rest || ms) % 1000;
    let milliseconds = rest || ms;
    return {hours, minutes, seconds, milliseconds}
};

const formatFileDate = date => `${(date.getDate()).toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;

let getLocalStorage = (key) => {
    if (window.localStorage && window.localStorage.getItem)
    {
        return window.localStorage.getItem( key )
    }
    return null;
};

let setLocalStorage = (key, value) => {
    if (window.localStorage && window.localStorage.setItem && window.localStorage.removeItem)
    {
        if (value === null || value === undefined)
        {
            return window.localStorage.removeItem( key );
        }
        else
        {
            window.localStorage.setItem(key, value);
        }
    }
};

let clearLocalStorage = () => {
    if (window.localStorage && window.localStorage.clear)
        return window.localStorage.clear();
};


module.exports = {
    addZero,
    objEach,
    isEmptyObj,
    clone,
    uniq,
    capitalizeFirstLetter,
    dateTime,
    getCookie,
    setCookie,
    randomIntInRange,
    randomFloatInRange,
    format,
    getValueFromJSON,
    setValueInJSON,
    renderDate,
    renderHours,
    getHumanName,
    getHumanEGN,
    password_generator,
    format_currency,
    ms_to_hours,
    formatFileDate,
    getLocalStorage,
    setLocalStorage,
    clearLocalStorage,
    numberFormat
};
